import { render, staticRenderFns } from "./InfoUtente.vue?vue&type=template&id=433370f7"
import script from "./InfoUtente.vue?vue&type=script&lang=ts"
export * from "./InfoUtente.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('433370f7')) {
      api.createRecord('433370f7', component.options)
    } else {
      api.reload('433370f7', component.options)
    }
    module.hot.accept("./InfoUtente.vue?vue&type=template&id=433370f7", function () {
      api.rerender('433370f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InfoUtente.vue"
export default component.exports